import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      text: 'Menudas manos, una pasada... ESPECTACULAR. La profesionalidad y dedicación se sienten desde el primer minuto.',
      author: 'Almudena Q.',
      role: 'Cliente habitual',
      image: 'https://public.readdy.ai/ai/img_res/e25072c1c59cadcaa20a0cf8f781ca1e.jpg'
    },
    {
      text: 'Un hallazgo. Con conocimiento de la anatomía y un precio razonable. El mejor masaje que he recibido en años.',
      author: 'Javier G.',
      role: 'Cliente satisfecho',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20satisfied%20male%20client%20smiling%20confident%20expression%20wellness%20spa%20customer%20testimonial%20authentic%20genuine%20relaxed%20peaceful%20face%20natural%20lighting%20warm%20atmosphere&width=400&height=500&seq=testimonial-client-002&orientation=portrait'
    },
    {
      text: 'Sientes el profesionalismo y la dedicación desde el primer minuto. Un lugar donde realmente te cuidan.',
      author: 'Tatiana M.',
      role: 'Cliente frecuente',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20happy%20woman%20client%20smiling%20warm%20expression%20wellness%20spa%20customer%20testimonial%20authentic%20genuine%20peaceful%20serene%20face%20soft%20lighting%20calming%20atmosphere&width=400&height=500&seq=testimonial-client-003&orientation=portrait'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-24 bg-[#2C3E2F] relative overflow-hidden">
      {/* Decorative Pattern */}
      <div className="absolute top-0 left-0 w-96 h-96 opacity-10">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <path
            d="M 20 100 Q 60 20, 100 60 T 180 100"
            stroke="#A8B5A0"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M 20 120 Q 60 40, 100 80 T 180 120"
            stroke="#A8B5A0"
            strokeWidth="2"
            fill="none"
          />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-serif text-5xl font-medium text-white mb-4">
            Lo que dicen nuestros clientes
          </h2>
          <div className="w-20 h-1 bg-[#A8B5A0] mx-auto"></div>
        </div>

        <div className="flex justify-center">
          <div className="w-full max-w-5xl">
            <div className="bg-black/95 rounded-[40px] overflow-hidden flex flex-col md:flex-row items-center md:items-stretch relative">
              {/* Image Area */}
              <div className="w-full md:w-1/3 relative md:absolute md:left-0 md:top-1/2 md:-translate-y-1/2 md:-translate-x-12 z-20">
                <div className="w-full h-64 md:h-96">
                  <img
                    src={current.image}
                    alt={current.author}
                    className="w-full h-full object-cover rounded-3xl"
                  />
                </div>
              </div>

              {/* Content Area */}
              <div className="w-full md:w-2/3 md:ml-auto p-8 md:p-16">
                <div className="text-[#F5F1E8] text-8xl font-serif leading-none mb-6 opacity-30">
                  "
                </div>
                <p className="font-serif text-2xl md:text-3xl text-white leading-relaxed mb-8">
                  {current.text}
                </p>
                <div className="mb-8">
                  <p className="font-sans font-bold text-lg text-white">
                    {current.author}
                  </p>
                  <p className="font-sans text-sm text-gray-400 mt-1">
                    {current.role}
                  </p>
                </div>

                {/* Navigation */}
                <div className="flex items-center space-x-4">
                  <button
                    onClick={prevTestimonial}
                    className="w-12 h-12 rounded-full border-2 border-white/30 text-white hover:bg-white hover:text-[#2C3E2F] transition-all duration-300 flex items-center justify-center"
                    aria-label="Anterior testimonio"
                  >
                    <i className="ri-arrow-left-line text-xl"></i>
                  </button>
                  <button
                    onClick={nextTestimonial}
                    className="w-12 h-12 rounded-full border-2 border-white/30 text-white hover:bg-white hover:text-[#2C3E2F] transition-all duration-300 flex items-center justify-center"
                    aria-label="Siguiente testimonio"
                  >
                    <i className="ri-arrow-right-line text-xl"></i>
                  </button>
                  <div className="flex space-x-2 ml-4">
                    {testimonials.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setCurrentIndex(idx)}
                        className={`w-2 h-2 rounded-full transition-all duration-300 ${
                          idx === currentIndex ? 'bg-white w-8' : 'bg-white/30'
                        }`}
                        aria-label={`Ir al testimonio ${idx + 1}`}
                      ></button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
